module.exports = __webpack_public_path__ + "img/banner-wechat-credit-pay.38c6dd38.png";